import fetchUserState from "@api/operations/fetch-customer-state";
import Customer from "@api/types/customer";
import { GetServerSideProps } from "next";
import React from "react";

import Center from "@components/Center";
import Container from "@components/Container";
import LicenseActivationForm from "@components/LicenseActivationForm";
import MainLayout from "@components/MainLayout";
import Title from "@components/Title";

import Activate from "../../components/Activate";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;
  const { sku } = query;

  // token may not exist yet if you have just accessed the site supply a mock customer in this case
  if (!token) {
    return {
      props: {
        sku: sku ? sku : "",
        customer: { guest: true },
        token: null,
      },
    };
  }

  const { customer } = await fetchUserState(token);

  return {
    props: {
      sku: sku ? sku : "",
      customer,
      token,
    },
  };
};

export default function LicenseActivationPage({
  sku,
  token,
  customer,
}: {
  sku: string;
  token: string;
  customer: Customer;
}) {
  return (
    <Container>
      <Title>License Activation</Title>
      {sku.length > 0 && <p className="sku">SKU: {sku}</p>}
      {customer.guest ? (
        <Center cy="login-required">
          Please{" "}
          <a href={"/login"} style={{ fontWeight: "bold", textDecoration: "underline" }}>
            log in or create
          </a>{" "}
          an account before attempting to activate a license.
        </Center>
      ) : (
        <LicenseActivationForm token={token} sku={sku} cy="activation-form" />
      )}
      <Activate />
      <style jsx>{`
        .sku {
          text-align: center;
          font-weight: bold;
        }
      `}</style>
    </Container>
  );
}

LicenseActivationPage.Layout = MainLayout;
